import { Injectable, inject } from '@angular/core';
import {DataService} from "../../../services/data.service";
import {AllDetailsService} from "../all-details/all-details.service";

@Injectable({
  providedIn: 'root',
})
export class DataTableService {
  ds = inject(DataService);
  as = inject(AllDetailsService);

  columnHeaderFromKeys(columnsKeys: string[], hasActionsColumn: boolean){
    if(!columnsKeys.length) return {};
    const columnHeader_: {[key: string]: string}= {index: '#'};

     columnsKeys?.forEach((s: string) => {
      let name = this.ds.camelToSpaced(this.as.getNameFromFieldString(s));
      name = this.ds.capitalizeFirstLetter(name.trim());
      const key = this.as.getKeyFromFieldString(s).trim();

      const isRenamed = this.ds.valueIncludes(name,' mod');
      columnHeader_[key] = isRenamed ? name.substring(0, name.length - 4) : name;
    });

    const hasAction = hasActionsColumn ||  columnsKeys.find(k => this.ds.valueIncludes(k,'action'));
    if(hasAction) columnHeader_['index']='Actions';
    return columnHeader_;
  }


}
